import jsPDF from 'jspdf';
import type { Payslip } from '../types';

export const generatePayslipPDF = (payslip: Payslip) => {
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(20);
  doc.text('PAYSLIP', 105, 30, { align: 'center' });
  
  doc.setFontSize(12);
  doc.text('Hospital Management System', 105, 45, { align: 'center' });
  doc.text('123 Medical Center Drive, Healthcare City', 105, 55, { align: 'center' });
  
  doc.setFontSize(14);
  doc.text('Employee Details', 20, 80);
  doc.setFontSize(10);
  doc.text(`Name: ${payslip.employee_name}`, 20, 95);
  doc.text(`Employee Code: ${payslip.employee_code}`, 20, 105);
  doc.text(`Department: ${payslip.department}`, 20, 115);
  doc.text(`Designation: ${payslip.designation}`, 20, 125);
  
  doc.text(`Pay Period: ${payslip.period_start} to ${payslip.period_end}`, 120, 95);
  doc.text(`Working Days: ${payslip.working_days}`, 120, 105);
  doc.text(`Present Days: ${payslip.present_days}`, 120, 115);
  doc.text(`Absent Days: ${payslip.absent_days}`, 120, 125);
  
  doc.setFontSize(14);
  doc.text('Earnings', 20, 150);
  doc.setFontSize(10);
  
  let yPos = 165;
  doc.text('Basic Salary:', 20, yPos);
  doc.text(`$${payslip.basic_salary.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 10;
  doc.text('House Rent Allowance:', 20, yPos);
  doc.text(`$${payslip.house_rent_allowance.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 10;
  doc.text('Transport Allowance:', 20, yPos);
  doc.text(`$${payslip.transport_allowance.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 10;
  doc.text('Medical Allowance:', 20, yPos);
  doc.text(`$${payslip.medical_allowance.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 10;
  doc.text('Other Allowances:', 20, yPos);
  doc.text(`$${payslip.other_allowances.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  if (payslip.overtime_hours > 0) {
    yPos += 10;
    doc.text(`Overtime (${payslip.overtime_hours} hrs):`, 20, yPos);
    doc.text(`$${payslip.overtime_amount.toFixed(2)}`, 150, yPos, { align: 'right' });
  }
  
  yPos += 15;
  doc.setFontSize(12);
  doc.text('Gross Earnings:', 20, yPos);
  doc.text(`$${payslip.gross_earnings.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 25;
  doc.setFontSize(14);
  doc.text('Deductions', 20, yPos);
  doc.setFontSize(10);
  
  yPos += 15;
  doc.text('Tax Deduction:', 20, yPos);
  doc.text(`$${payslip.tax_deduction.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 10;
  doc.text('Provident Fund:', 20, yPos);
  doc.text(`$${payslip.provident_fund.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 10;
  doc.text('Insurance Deduction:', 20, yPos);
  doc.text(`$${payslip.insurance_deduction.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  if (payslip.loan_deduction > 0) {
    yPos += 10;
    doc.text('Loan Deduction:', 20, yPos);
    doc.text(`$${payslip.loan_deduction.toFixed(2)}`, 150, yPos, { align: 'right' });
  }
  
  if (payslip.unpaid_leave_deduction > 0) {
    yPos += 10;
    doc.text('Unpaid Leave Deduction:', 20, yPos);
    doc.text(`$${payslip.unpaid_leave_deduction.toFixed(2)}`, 150, yPos, { align: 'right' });
  }
  
  if (payslip.other_deductions > 0) {
    yPos += 10;
    doc.text('Other Deductions:', 20, yPos);
    doc.text(`$${payslip.other_deductions.toFixed(2)}`, 150, yPos, { align: 'right' });
  }
  
  yPos += 15;
  doc.setFontSize(12);
  doc.text('Total Deductions:', 20, yPos);
  doc.text(`$${payslip.total_deductions.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  yPos += 20;
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('NET SALARY:', 20, yPos);
  doc.text(`$${payslip.net_salary.toFixed(2)}`, 150, yPos, { align: 'right' });
  
  if (payslip.status === 'paid' && payslip.payment_date) {
    yPos += 20;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Payment Date: ${payslip.payment_date}`, 20, yPos);
    if (payslip.payment_method) {
      doc.text(`Payment Method: ${payslip.payment_method.replace('_', ' ').toUpperCase()}`, 20, yPos + 10);
    }
    if (payslip.payment_reference) {
      doc.text(`Reference: ${payslip.payment_reference}`, 20, yPos + 20);
    }
  }
  
  doc.setFontSize(8);
  doc.text('This is a computer-generated payslip and does not require a signature.', 105, 280, { align: 'center' });
  
  return doc;
};

export const downloadPayslipPDF = (payslip: Payslip) => {
  const doc = generatePayslipPDF(payslip);
  const filename = `Payslip_${payslip.employee_code}_${payslip.period_start.replace(/-/g, '')}_${payslip.id}.pdf`;
  doc.save(filename);
};

export const printPayslip = (payslip: Payslip) => {
  const doc = generatePayslipPDF(payslip);
  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank');
};
